// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"card-property_sliderContainer__xpwMl"};